module.exports = __webpack_public_path__ + "img/gongan.17095068.png";